import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-calendar",
  "use": "icon-calendar-usage",
  "viewBox": "0 0 18 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 19\" id=\"icon-calendar\"><path d=\"M14 3V0h-2v3H6V0H4v3H0v16h18V3h-4zM2 5h4v3.5H2V5zm0 4.5h4v3H2v-3zm0 4h4V17H2v-3.5zm9 3.5H7v-3.5h4V17zm0-4.5H7v-3h4v3zm0-4H7V5h4v3.5zm5 8.5h-4v-3.5h4V17zm0-4.5h-4v-3h4v3zm0-4h-4V5h4v3.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol